import { Card, Col, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReactComponent as CalendarSVG } from "go-core/images/svg/calendar.svg";
import { ReactComponent as InvoiceTypeSVG } from "go-core/images/svg/file.svg";
import { KSeFInvoiceApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	ksefData?: KSeFInvoiceApi;
	refetchingInvoiceInProgress?: boolean;
}

export const KSeFInfoCard = ({ ksefData, refetchingInvoiceInProgress }: Props) => {
	const { t } = useTranslation();

	return (
		<Col xs={12}>
			<Card>
				<Card.Body>
					{(Boolean(ksefData) || (!ksefData && refetchingInvoiceInProgress)) && (
						<>
							<Card.Title as="h5">{t("modules.invoice.header.ksef_info.title")}</Card.Title>
							{refetchingInvoiceInProgress && (
								<div className="d-flex align-items-center column-gap-1 mb-3 ms-1">
									<Spinner size="sm" variant="primary" />
									<p className="mb-0">
										{t("modules.invoice.action.sending_to_ksef_in_progress.title")}
									</p>
								</div>
							)}
						</>
					)}
					{ksefData && (
						<Row>
							<Col md={3} className="card-body-item">
								<CalendarSVG />
								<div className="item-info">
									<span className="label">{t("lib:common.word.created_at")}</span>
									<span>{FormatDate(ksefData.created_at)}</span>
								</div>
							</Col>
							<Col md={3} className="card-body-item">
								<InvoiceTypeSVG />
								<div className="item-info">
									<span className="label">{t("lib:common.word.status")}</span>
									<span>
										{t(`enums.common.status.${ksefData.status}`, { ns: ["lib", "translation"] })}
									</span>
								</div>
							</Col>
							{ksefData.number && (
								<Col md={3} className="card-body-item">
									<InvoiceTypeSVG />
									<div className="item-info">
										<span className="label">{t("modules.invoice.field.ksef_number.title")}</span>
										<span>{ksefData.number}</span>
									</div>
								</Col>
							)}
							{ksefData.last_check_at && (
								<Col md={3} className="card-body-item">
									<CalendarSVG />
									<div className="item-info">
										<span className="label">{t("modules.invoice.field.last_check_at.title")}</span>
										<span>{FormatDate(ksefData.last_check_at)}</span>
									</div>
								</Col>
							)}
							{ksefData.error && (
								<Col md={6} className="card-body-item">
									<InvoiceTypeSVG />
									<div className="item-info">
										<span className="label">{t("modules.invoice.field.error.title")}</span>
										<p className="text-break">{ksefData.error}</p>
									</div>
								</Col>
							)}
						</Row>
					)}
				</Card.Body>
			</Card>
		</Col>
	);
};

// t("enums.common.status.PENDING")
